import pathsUrl from './urlpaths';

// Get the current URL path
const url = window.location.pathname;

// Check if the current URL path is in the `pathsUrl` array
if (!pathsUrl.includes(url)) {
	// Dynamically import the CSS file
	import('../css/tutorial.css');
}
